import React, { useState, useEffect } from "react";
import "./SimplePagination.scss";

interface SimplePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const SimplePagination: React.FC<SimplePaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange
}) => {
  const [inputPage, setInputPage] = useState<string>(currentPage.toString());

  useEffect(() => {
    setInputPage(currentPage.toString());
  }, [currentPage]);

  const handleFirstPage = () => {
    if (currentPage > 1) {
      onPageChange(1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      onPageChange(totalPages);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputPage(e.target.value);
  };

  const handleInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleInputSubmit();
    }
  };

  const handleInputBlur = () => {
    handleInputSubmit();
  };

  const handleInputSubmit = () => {
    const pageNumber = parseInt(inputPage, 10);
    if (
      pageNumber >= 1 &&
      pageNumber <= totalPages &&
      pageNumber !== currentPage
    ) {
      onPageChange(pageNumber);
    } else {
      // Reset to current page if invalid
      setInputPage(currentPage.toString());
    }
  };

  return (
    <div className="simple-pagination">
      <button
        className="pagination-btn"
        onClick={handleFirstPage}
        disabled={currentPage === 1}
        title="First page"
      >
        &lt;&lt;
      </button>

      <button
        className="pagination-btn"
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
        title="Previous page"
      >
        &lt;
      </button>

      <div className="page-input-container">
        <input
          type="text"
          className="page-input"
          value={inputPage}
          onChange={handleInputChange}
          onKeyPress={handleInputKeyPress}
          onBlur={handleInputBlur}
        />
        <span className="page-divider">/</span>
        <span className="total-pages">{totalPages}</span>
      </div>

      <button
        className="pagination-btn"
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        title="Next page"
      >
        &gt;
      </button>

      <button
        className="pagination-btn"
        onClick={handleLastPage}
        disabled={currentPage === totalPages}
        title="Last page"
      >
        &gt;&gt;
      </button>
    </div>
  );
};

export default SimplePagination;
